import { useQuery } from "@apollo/client/react";
import {
  CountriesDocument,
  DegreesDocument,
  GendersDocument,
  IndustriesDocument,
  JobDepartmentsDocument,
  JobLocationsDocument,
  MaritalStatusesDocument,
} from "@/graphql/generated/operations";

export interface ReferenceOption {
  value: string;
  label: string;
}

export interface UseRequirementsReferenceDataResult {
  genders: ReferenceOption[];
  maritalStatuses: ReferenceOption[];
  countries: ReferenceOption[];
  jobDepartments: ReferenceOption[];
  jobLocations: ReferenceOption[];
  industries: ReferenceOption[];
  degrees: ReferenceOption[];
  loading: boolean;
}

export function useRequirementsReferenceData(): UseRequirementsReferenceDataResult {
  const gendersQ = useQuery(GendersDocument);
  const maritalQ = useQuery(MaritalStatusesDocument);
  const countriesQ = useQuery(CountriesDocument);
  const jobDepartmentsQ = useQuery(JobDepartmentsDocument);
  const jobLocationsQ = useQuery(JobLocationsDocument);
  const industriesQ = useQuery(IndustriesDocument);
  const degreesQ = useQuery(DegreesDocument);

  return {
    genders: (gendersQ.data?.genders.genders ?? []).map((g) => ({
      value: g.id,
      label: g.name ?? g.id,
    })),
    maritalStatuses: (maritalQ.data?.maritalStatuses.maritalStatuses ?? []).map((m) => ({
      value: m.id,
      label: m.name ?? m.id,
    })),
    countries: (countriesQ.data?.countries.countries ?? []).map((c) => ({
      value: c.id,
      label: c.name ?? c.iso2 ?? c.id,
    })),
    jobDepartments: (jobDepartmentsQ.data?.jobDepartments.jobDepartments ?? []).map((d) => ({
      value: d.id,
      label: d.localizedName?.localized ?? d.id,
    })),
    jobLocations: (jobLocationsQ.data?.jobLocations.jobLocations ?? []).map((l) => ({
      value: l.id,
      label: l.localizedName?.localized ?? l.id,
    })),
    industries: (industriesQ.data?.industries.industries ?? []).map((i) => ({
      value: i.id,
      label: i.localizedName?.localized ?? i.name ?? i.id,
    })),
    degrees: (degreesQ.data?.degrees.degrees ?? []).map((degree) => ({
      value: degree.id,
      label: degree.localizedName?.localized ?? degree.name ?? degree.id,
    })),
    loading:
      gendersQ.loading ||
      maritalQ.loading ||
      countriesQ.loading ||
      jobDepartmentsQ.loading ||
      jobLocationsQ.loading ||
      industriesQ.loading ||
      degreesQ.loading,
  };
}
